import { gql } from '@apollo/client'

export interface IDataType {
  trendSummedCashControlDetails: {
    nodes: {
      startDate: string
      endDate: string
      cashControlDetails: Record<string, Record<string, number>>
    }[]
  }
  trendLocationGroupMetricValuesByDateRangeNumber?: {
    nodes: {
      startDate: string
      endDate: string
      metricSummaryData: Record<
        string,
        {
          name: string
          unit: 'CENT' | 'PERCENTAGE' | 'DOLLAR' | 'COUNT'
          value: number
        }
      >
    }[]
  }
}

export const TREND_SUMMED_CASH_CONTROL_DETAILS = gql`
  query TrendSummedCashControlDetails(
    $iFilter: JSON!
    $iEndDate: Date!
    $iGroupBy: String!
    $iDateRangeNumber: Int
    $useMetrics: Boolean!
  ) {
    trendSummedCashControlDetails(
      iFilter: $iFilter
      iEndDate: $iEndDate
      iGroupBy: $iGroupBy
      iDateRangeNumber: $iDateRangeNumber
    ) {
      nodes {
        startDate
        endDate
        cashControlDetails
      }
    }

    trendLocationGroupMetricValuesByDateRangeNumber(
      iFilter: $iFilter
      iEndDate: $iEndDate
      iGroupBy: $iGroupBy
      iDateRangeNumber: $iDateRangeNumber
    ) @include(if: $useMetrics) {
      nodes {
        startDate
        endDate
        metricSummaryData
      }
    }
  }
`
